<template lang="pug">
  .message-form.mt-3
    b-textarea(
      v-model="message_body"
      class="mb-3"
      rows="3"
      max-rows="10"
      @keyup.meta.enter="send_message"
      @keyup.ctrl.enter="send_message"
    )
    .d-flex.justify-content-between.align-items-center
      b-btn(@click="send_message" size="sm") Отправить сообщение
      socket-state(:state="socket_state")

</template>

<script>
import SocketState from "../common/SocketState";
export default {
name: "MessageForm",
  components: {SocketState},
  props: {
    order_id: [Number, String],
    socket_state: String,
  },
  data(){
    return {
    }
  },
  computed:{
    message_body: {
      get(){
        return this.$store.state.messages.message_body;
      },
      set(value){
        this.$store.commit('messages/setMessageBody', value)
      },
    }
  },
  methods: {
    send_message(){
      if (this.message_body.length > 0) {
        this.$emit('submit', this.message_body);
      }
    },
  }
}
</script>

<style scoped>

</style>